"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getThreepidsWithBindStatus = undefined;

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _bluebird = require("bluebird");

var getThreepidsWithBindStatus = exports.getThreepidsWithBindStatus = function () {
    var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee(client, filterMedium) {
        var userId, _ref2, threepids, authClient, identityAccessToken, query, lookupResults, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, _ret;

        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        userId = client.getUserId();
                        _context.next = 3;
                        return (0, _bluebird.resolve)(client.getThreePids());

                    case 3:
                        _ref2 = _context.sent;
                        threepids = _ref2.threepids;

                        if (filterMedium) {
                            threepids = threepids.filter(function (a) {
                                return a.medium === filterMedium;
                            });
                        }

                        // Check bind status assuming we have an IS and terms are agreed

                        if (!(threepids.length > 0 && !!client.getIdentityServerUrl())) {
                            _context.next = 49;
                            break;
                        }

                        _context.prev = 7;
                        authClient = new _IdentityAuthClient2.default();
                        _context.next = 11;
                        return (0, _bluebird.resolve)(authClient.getAccessToken({ check: false }));

                    case 11:
                        identityAccessToken = _context.sent;


                        // Restructure for lookup query
                        query = threepids.map(function (_ref3) {
                            var medium = _ref3.medium,
                                address = _ref3.address;
                            return [medium, address];
                        });
                        _context.next = 15;
                        return (0, _bluebird.resolve)(client.bulkLookupThreePids(query, identityAccessToken));

                    case 15:
                        lookupResults = _context.sent;


                        // Record which are already bound
                        _iteratorNormalCompletion = true;
                        _didIteratorError = false;
                        _iteratorError = undefined;
                        _context.prev = 19;

                        _loop = function _loop() {
                            var _step$value = (0, _slicedToArray3.default)(_step.value, 3),
                                medium = _step$value[0],
                                address = _step$value[1],
                                mxid = _step$value[2];

                            if (mxid !== userId) {
                                return "continue";
                            }
                            if (filterMedium && medium !== filterMedium) {
                                return "continue";
                            }
                            var threepid = threepids.find(function (e) {
                                return e.medium === medium && e.address === address;
                            });
                            if (!threepid) return "continue";
                            threepid.bound = true;
                        };

                        _iterator = (0, _getIterator3.default)(lookupResults.threepids);

                    case 22:
                        if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                            _context.next = 29;
                            break;
                        }

                        _ret = _loop();

                        if (!(_ret === "continue")) {
                            _context.next = 26;
                            break;
                        }

                        return _context.abrupt("continue", 26);

                    case 26:
                        _iteratorNormalCompletion = true;
                        _context.next = 22;
                        break;

                    case 29:
                        _context.next = 35;
                        break;

                    case 31:
                        _context.prev = 31;
                        _context.t0 = _context["catch"](19);
                        _didIteratorError = true;
                        _iteratorError = _context.t0;

                    case 35:
                        _context.prev = 35;
                        _context.prev = 36;

                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }

                    case 38:
                        _context.prev = 38;

                        if (!_didIteratorError) {
                            _context.next = 41;
                            break;
                        }

                        throw _iteratorError;

                    case 41:
                        return _context.finish(38);

                    case 42:
                        return _context.finish(35);

                    case 43:
                        _context.next = 49;
                        break;

                    case 45:
                        _context.prev = 45;
                        _context.t1 = _context["catch"](7);

                        if (_context.t1.errcode === "M_TERMS_NOT_SIGNED") {
                            _context.next = 49;
                            break;
                        }

                        throw _context.t1;

                    case 49:
                        return _context.abrupt("return", threepids);

                    case 50:
                    case "end":
                        return _context.stop();
                }
            }
        }, _callee, this, [[7, 45], [19, 31, 35, 43], [36,, 38, 42]]);
    }));

    return function getThreepidsWithBindStatus(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}(); /*
     Copyright 2019 The Matrix.org Foundation C.I.C.
     
     Licensed under the Apache License, Version 2.0 (the "License");
     you may not use this file except in compliance with the License.
     You may obtain a copy of the License at
     
         http://www.apache.org/licenses/LICENSE-2.0
     
     Unless required by applicable law or agreed to in writing, software
     distributed under the License is distributed on an "AS IS" BASIS,
     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     See the License for the specific language governing permissions and
     limitations under the License.
     */

var _IdentityAuthClient = require("./IdentityAuthClient");

var _IdentityAuthClient2 = _interopRequireDefault(_IdentityAuthClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=boundThreepids.js.map